import { render, staticRenderFns } from "./LottoHistory.vue?vue&type=template&id=80004a74&"
import script from "./LottoHistory.vue?vue&type=script&lang=js&"
export * from "./LottoHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports